<template>
  <div class="loader" v-if="isLoading">
    <div class="loader-content">
      <svg class="loader-svg" viewBox="0 0 200 200">
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color: #ff6b81; stop-opacity: 1" />
            <stop offset="100%" style="stop-color: #3c4560; stop-opacity: 1" />
          </linearGradient>
        </defs>
        <text class="loader-text" x="100" y="100" alignment-baseline="middle" text-anchor="middle" font-size="48" fill="url(#gradient)">
          <tspan x="100" y="100">华胤集团</tspan>
          <tspan x="100" y="150">Loading...</tspan>
          
        </text>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Loader',
  data() {
    return {
      isLoading: true,
    };
  },
};
</script>

<style scoped>
.loader {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1) !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-content {
  text-align: center;
}

.loader-svg {
  width: 100px;
  height: 100px;
}

.loader-text {
  font-family: 'Arial', sans-serif;
  animation: text-fade 0s linear infinite;
}

@keyframes text-fade {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>